/**
 *
 *  __  __            _   _   _____            _______   ____  _____  __     __
 * |  \/  |    /\    | \ | | |  __ \     /\   |__   __| / __ \|  __ \ \ \   / /
 * | \  / |   /  \   |  \| | | |  | |   /  \     | |   | |  | | |__) | \ \_/ /
 * | |\/| |  / /\ \  | . ` | | |  | |  / /\ \    | |   | |  | |  _  /   \   /
 * | |  | | / ____ \ | |\  | | |__| | / ____ \   | |   | |__| | | \ \    | |
 * |_|  |_|/_/    \_\|_| \_| |_____/ /_/    \_\  |_|    \____/|_|  \_\   |_|
 *
 *
 * IF YOU NEED TO ADD A NEW ELEMENT, RESPECT THE ALPHABETICAL ORDER
 *
 * svg fill="none", REMOVE OTHER "fill" properties
 *
 */

export const SVGIcons = {
  add: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="15" height="15" rx="5" fill="#EAEAEA" />
      <path d="M10.4167 6.91667H8.08333V4.58333C8.08333 4.42862 8.02187 4.28025 7.91248 4.17085C7.80308 4.06146 7.65471 4 7.5 4C7.34529 4 7.19692 4.06146 7.08752 4.17085C6.97812 4.28025 6.91667 4.42862 6.91667 4.58333V6.91667H4.58333C4.42862 6.91667 4.28025 6.97812 4.17085 7.08752C4.06146 7.19692 4 7.34529 4 7.5C4 7.65471 4.06146 7.80308 4.17085 7.91248C4.28025 8.02187 4.42862 8.08333 4.58333 8.08333H6.91667V10.4167C6.91667 10.5714 6.97812 10.7197 7.08752 10.8291C7.19692 10.9385 7.34529 11 7.5 11C7.65471 11 7.80308 10.9385 7.91248 10.8291C8.02187 10.7197 8.08333 10.5714 8.08333 10.4167V8.08333H10.4167C10.5714 8.08333 10.7197 8.02187 10.8291 7.91248C10.9385 7.80308 11 7.65471 11 7.5C11 7.34529 10.9385 7.19692 10.8291 7.08752C10.7197 6.97812 10.5714 6.91667 10.4167 6.91667Z" />
    </svg>
  ),

  align: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 7H1C0.4 7 0 6.6 0 6C0 5.4 0.4 5 1 5H12.6L9.3 1.7C8.9 1.3 8.9 0.7 9.3 0.3C9.7 -0.1 10.3 -0.1 10.7 0.3L15.7 5.3C16 5.6 16.1 6 15.9 6.4C15.7 6.8 15.4 7 15 7Z" />
      <path d="M6.00015 16C5.70015 16 5.50015 15.9 5.30015 15.7L0.300146 10.7C0.000145584 10.4 -0.0998544 10 0.100146 9.6C0.300146 9.2 0.600146 9 1.00015 9H15.0001C15.6001 9 16.0001 9.4 16.0001 10C16.0001 10.6 15.6001 11 15.0001 11H3.40015L6.70015 14.3C7.10015 14.7 7.10015 15.3 6.70015 15.7C6.50015 15.9 6.30015 16 6.00015 16Z" />
    </svg>
  ),

  anchor: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.32679 1.28698L6.30279 3.26164C6.11602 3.44732 6.01003 3.69917 6.00785 3.96252C6.00566 4.22587 6.10745 4.47945 6.2911 4.6682C6.47476 4.85695 6.72547 4.96563 6.98878 4.97065C7.25209 4.97566 7.50675 4.8766 7.69746 4.69498L9.73346 2.71098C9.96427 2.47105 10.2407 2.27964 10.5465 2.14798C10.8523 2.01633 11.1813 1.94708 11.5142 1.94429C11.8471 1.94151 12.1773 2.00526 12.4852 2.13178C12.7932 2.25831 13.0727 2.44507 13.3075 2.68111C13.5423 2.91715 13.7276 3.19771 13.8525 3.50633C13.9774 3.81494 14.0394 4.1454 14.0349 4.4783C14.0303 4.8112 13.9593 5.13984 13.8261 5.44493C13.6928 5.75003 13.4999 6.02543 13.2588 6.25498L11.2841 8.28031C11.1906 8.37396 11.1167 8.48522 11.0665 8.60766C11.0164 8.7301 10.991 8.86128 10.9919 8.9936C10.9928 9.12591 11.0199 9.25673 11.0718 9.37848C11.1236 9.50022 11.1991 9.61047 11.2938 9.70283C11.3886 9.7952 11.5007 9.86784 11.6237 9.91655C11.7467 9.96526 11.8782 9.98908 12.0105 9.98661C12.1428 9.98414 12.2733 9.95544 12.3944 9.90218C12.5155 9.84892 12.6249 9.77214 12.7161 9.67631L14.6828 7.66031C15.5248 6.81536 15.9975 5.67115 15.9975 4.47831C15.9975 3.28547 15.5248 2.14126 14.6828 1.29631C13.8262 0.480803 12.6893 0.0251792 11.5067 0.0234425C10.324 0.0217058 9.18574 0.473988 8.32679 1.28698V1.28698Z" />
      <path d="M8.30278 11.2612L6.26678 13.2465C6.03485 13.4819 5.75855 13.669 5.45386 13.797C5.14917 13.9249 4.82214 13.9912 4.49167 13.992C4.16121 13.9927 3.83387 13.928 3.5286 13.8014C3.22332 13.6749 2.94616 13.4891 2.71315 13.2547C2.48014 13.0204 2.2959 12.7422 2.17108 12.4362C2.04627 12.1302 1.98336 11.8025 1.98599 11.4721C1.98862 11.1416 2.05674 10.8149 2.18641 10.511C2.31609 10.207 2.50473 9.93178 2.74145 9.70119L4.71611 7.67586C4.89758 7.48525 4.99659 7.23081 4.99168 6.96768C4.98677 6.70456 4.87834 6.45398 4.6899 6.27028C4.50146 6.08657 4.2482 5.98456 3.98504 5.98635C3.72188 5.98814 3.47003 6.0936 3.28411 6.27986L1.31745 8.29586C0.492059 9.14273 0.0332022 10.2805 0.0401161 11.463C0.0470299 12.6456 0.519159 13.7779 1.35439 14.615C2.18963 15.4522 3.32083 15.9269 4.50336 15.9366C5.68588 15.9462 6.82468 15.49 7.67345 14.6665L9.69745 12.6945C9.88422 12.5088 9.9902 12.257 9.99239 11.9936C9.99458 11.7303 9.89279 11.4767 9.70913 11.288C9.52547 11.0992 9.27477 10.9905 9.01146 10.9855C8.74815 10.9805 8.49349 11.0796 8.30278 11.2612Z" />
      <path d="M4.62686 11.3518C4.71952 11.4448 4.82965 11.5186 4.95092 11.569C5.07219 11.6194 5.20221 11.6453 5.33353 11.6453C5.46484 11.6453 5.59487 11.6194 5.71613 11.569C5.8374 11.5186 5.94753 11.4448 6.04019 11.3518L11.3735 6.01844C11.4691 5.92624 11.5453 5.81593 11.5978 5.69395C11.6502 5.57197 11.6779 5.44076 11.6791 5.30799C11.6803 5.17521 11.6551 5.04352 11.6049 4.9206C11.5546 4.79768 11.4804 4.68599 11.3866 4.59205C11.2927 4.49812 11.1811 4.42381 11.0583 4.37347C10.9354 4.32314 10.8037 4.29777 10.6709 4.29886C10.5382 4.29995 10.4069 4.32748 10.2849 4.37983C10.1629 4.43218 10.0525 4.50831 9.96019 4.60377L4.62686 9.93711C4.53393 10.03 4.46022 10.1402 4.40992 10.2616C4.35963 10.383 4.33374 10.5131 4.33374 10.6444C4.33374 10.7758 4.35963 10.9059 4.40992 11.0273C4.46022 11.1486 4.53393 11.2589 4.62686 11.3518V11.3518Z" />
    </svg>
  ),

  arrowBack: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.7 14L8.1 12.6418L3.8 8.47015H16V6.52985H3.8L8.1 2.35821L6.7 1L0 7.5L6.7 14Z" />
    </svg>
  ),

  arrowDown: (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.293 1.29357L6.00004 5.58657L1.70704 1.29357C1.51844 1.11141 1.26584 1.01062 1.00364 1.0129C0.741443 1.01517 0.49063 1.12034 0.305222 1.30575C0.119814 1.49116 0.0146453 1.74197 0.0123669 2.00417C0.0100885 2.26636 0.110883 2.51897 0.293041 2.70757L5.29304 7.70757C5.48057 7.89504 5.73488 8.00036 6.00004 8.00036C6.26521 8.00036 6.51951 7.89504 6.70704 7.70757L11.707 2.70757C11.8026 2.61532 11.8787 2.50498 11.9311 2.38297C11.9836 2.26097 12.0111 2.12975 12.0123 1.99697C12.0134 1.86419 11.9881 1.73251 11.9379 1.60962C11.8876 1.48672 11.8133 1.37507 11.7194 1.28117C11.6255 1.18728 11.5139 1.11303 11.391 1.06275C11.2681 1.01247 11.1364 0.987165 11.0036 0.988319C10.8709 0.989473 10.7396 1.01706 10.6176 1.06947C10.4956 1.12188 10.3853 1.19806 10.293 1.29357Z" />
    </svg>
  ),

  arrowLeftScroll: (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.10498 4L6.10961 7.4641L6.10961 0.535899L0.10498 4Z" />
    </svg>
  ),

  arrowNext: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(-1 1)"
    >
      <path d="M6.7 14L8.1 12.6418L3.8 8.47015H16V6.52985H3.8L8.1 2.35821L6.7 1L0 7.5L6.7 14Z" />
    </svg>
  ),

  arrowRightScroll: (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.99219 4L0.987558 0.535899L0.987558 7.4641L6.99219 4Z" />
    </svg>
  ),

  arrowToRight: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3536 6.35355C10.5488 6.15829 10.5488 5.84171 10.3536 5.64645L7.17157 2.46447C6.97631 2.2692 6.65973 2.2692 6.46447 2.46447C6.2692 2.65973 6.2692 2.97631 6.46447 3.17157L9.29289 6L6.46447 8.82843C6.2692 9.02369 6.2692 9.34027 6.46447 9.53553C6.65973 9.7308 6.97631 9.7308 7.17157 9.53553L10.3536 6.35355ZM1 6.5L10 6.5L10 5.5L1 5.5L1 6.5Z" />
    </svg>
  ),

  arrowUp: (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.70696 6.70643L6.99996 2.41343L11.293 6.70643C11.4816 6.88859 11.7342 6.98938 11.9964 6.9871C12.2586 6.98483 12.5094 6.87966 12.6948 6.69425C12.8802 6.50884 12.9854 6.25803 12.9876 5.99583C12.9899 5.73364 12.8891 5.48103 12.707 5.29243L7.70696 0.29243C7.51943 0.104959 7.26512 -0.000356221 6.99996 -0.000356244C6.7348 -0.000356267 6.48049 0.104959 6.29296 0.29243L1.29296 5.29243C1.19745 5.38468 1.12127 5.49502 1.06886 5.61703C1.01645 5.73903 0.988862 5.87025 0.987708 6.00303C0.986554 6.13581 1.01186 6.26749 1.06214 6.39038C1.11242 6.51328 1.18667 6.62493 1.28056 6.71882C1.37446 6.81272 1.48611 6.88697 1.609 6.93725C1.7319 6.98753 1.86358 7.01283 1.99636 7.01168C2.12914 7.01053 2.26036 6.98294 2.38236 6.93053C2.50437 6.87812 2.61471 6.80194 2.70696 6.70643Z" />
    </svg>
  ),

  bell: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.5049 11.3638C14.2934 10.3895 13.5996 8.96899 13.5996 7.46286V5.33928C13.5996 2.65893 11.5068 0.442561 8.79884 0.0713808C8.79884 0.0713808 8.39003 0 8.01872 0C7.64742 0 7.2011 0.0713808 7.2011 0.0713808C4.48944 0.442561 2.40037 2.6625 2.40037 5.33928V7.46286C2.40037 8.96899 1.70651 10.393 0.491325 11.371C0.180027 11.6244 0 11.992 0 12.3846C0 13.1198 0.626346 13.7158 1.39896 13.7158H14.601C15.3736 13.7158 15.9999 13.1198 15.9999 12.3846C16.0037 11.992 15.8237 11.6244 15.5049 11.3638Z" />
      <path d="M8.00018 16C9.4479 16 10.6631 15.0185 10.9406 13.7158H5.06348C5.34102 15.0185 6.55245 16 8.00018 16Z" />
    </svg>
  ),

  bulletList: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8788_324468)">
        <path d="M1.49798 3C2.32529 3 2.99596 2.32843 2.99596 1.5C2.99596 0.671573 2.32529 0 1.49798 0C0.670668 0 0 0.671573 0 1.5C0 2.32843 0.670668 3 1.49798 3Z" />
        <path d="M1.49798 9C2.32529 9 2.99596 8.32843 2.99596 7.5C2.99596 6.67157 2.32529 6 1.49798 6C0.670668 6 0 6.67157 0 7.5C0 8.32843 0.670668 9 1.49798 9Z" />
        <path d="M11.9839 0.75H4.49396V2.25H11.9839V0.75Z" />
        <path d="M11.9839 9.75H4.49396V11.25H11.9839V9.75Z" />
        <path d="M11.9839 6.75H4.49396V8.25H11.9839V6.75Z" />
        <path d="M11.9839 3.75H4.49396V5.25H11.9839V3.75Z" />
      </g>
      <defs>
        <clipPath id="clip0_8788_324468">
          <rect width="11.9838" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  burgerMenu: (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H11C11.5523 6 12 5.55228 12 5C12 4.44772 11.5523 4 11 4Z" />
      <path d="M11 0H1C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0Z" />
      <path d="M11 8H1C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10H11C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8Z" />
    </svg>
  ),

  cal: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.25 1.5H9.75V0H8.25V1.5H3.75V0H2.25V1.5H0.75C0.336 1.5 0 1.836 0 2.25V3.75H12V2.25C12 1.836 11.664 1.5 11.25 1.5Z" />
      <path d="M0 4.5V11.25C0 11.7 0.3 12 0.75 12H11.25C11.7 12 12 11.7 12 11.25V4.5H0Z" />
    </svg>
  ),

  camera: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5L0 10.5C0 10.8978 0.158035 11.2794 0.43934 11.5607C0.720644 11.842 1.10218 12 1.5 12H10.5C10.8978 12 11.2794 11.842 11.5607 11.5607C11.842 11.2794 12 10.8978 12 10.5V3.5C12 3.10218 11.842 2.72064 11.5607 2.43934C11.2794 2.15804 10.8978 2 10.5 2ZM7.5 9.5C7.00555 9.5 6.5222 9.35338 6.11107 9.07867C5.69995 8.80397 5.37952 8.41352 5.1903 7.95671C5.00108 7.49989 4.95157 6.99723 5.04804 6.51227C5.1445 6.02732 5.3826 5.58186 5.73223 5.23223C6.08186 4.8826 6.52732 4.6445 7.01227 4.54804C7.49723 4.45157 7.99989 4.50108 8.45671 4.6903C8.91352 4.87952 9.30397 5.19995 9.57867 5.61107C9.85338 6.0222 10 6.50555 10 7C10 7.66304 9.73661 8.29893 9.26777 8.76777C8.79893 9.23661 8.16304 9.5 7.5 9.5Z" />
      <path d="M6 0H2V1H6V0Z" />
    </svg>
  ),

  chartCandleStick: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 3H5V0H3V3H2C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V11C1 11.2652 1.10536 11.5196 1.29289 11.7071C1.48043 11.8946 1.73478 12 2 12H3V16H5V12H6C6.26522 12 6.51957 11.8946 6.70711 11.7071C6.89464 11.5196 7 11.2652 7 11V4C7 3.73478 6.89464 3.48043 6.70711 3.29289C6.51957 3.10536 6.26522 3 6 3Z" />
      <path d="M14 5H13V0H11V5H10C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6V13C9 13.2652 9.10536 13.5196 9.29289 13.7071C9.48043 13.8946 9.73478 14 10 14H11V16H13V14H14C14.2652 14 14.5196 13.8946 14.7071 13.7071C14.8946 13.5196 15 13.2652 15 13V6C15 5.73478 14.8946 5.48043 14.7071 5.29289C14.5196 5.10536 14.2652 5 14 5Z" />
    </svg>
  ),

  chartLine: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.56198 7.04813L6.02098 7.41513L6.39998 6.55313L9.39998 8.80013C9.50875 8.88173 9.63303 8.94029 9.76521 8.97223C9.89738 9.00417 10.0347 9.00881 10.1687 8.98588C10.3028 8.96295 10.4307 8.91292 10.5447 8.83886C10.6588 8.7648 10.7565 8.66825 10.832 8.55513L14.832 2.55513C14.9792 2.33447 15.0327 2.06437 14.9807 1.80426C14.9288 1.54415 14.7756 1.31532 14.555 1.16813C14.3343 1.02093 14.0642 0.967424 13.8041 1.01937C13.544 1.07132 13.3152 1.22447 13.168 1.44513L9.75398 6.56613L6.59998 4.20013C6.47972 4.10991 6.34067 4.04797 6.19318 4.01892C6.04568 3.98986 5.89352 3.99443 5.74804 4.03229C5.60255 4.07015 5.46747 4.14033 5.35284 4.2376C5.23822 4.33487 5.14701 4.45674 5.08598 4.59413L4.22998 6.52013C4.71599 6.5624 5.17901 6.74594 5.56198 7.04813Z" />
      <path d="M3.12291 11.5H2.01591L1.08591 13.594C1.03258 13.714 1.00341 13.8434 1.00008 13.9747C0.996745 14.106 1.01931 14.2366 1.06648 14.3592C1.11366 14.4818 1.18452 14.5939 1.27501 14.6891C1.36551 14.7843 1.47387 14.8607 1.59391 14.914C1.72162 14.9711 1.86001 15.0004 1.99991 15C2.19356 15.0002 2.38311 14.9442 2.54554 14.8388C2.70797 14.7333 2.83629 14.583 2.91491 14.406L3.92291 12.139L3.12291 11.5Z" />
      <path d="M9 14C8.77284 14.0001 8.55241 13.9229 8.375 13.781L3.649 10H1C0.734784 10 0.48043 9.89464 0.292893 9.70711C0.105357 9.51957 0 9.26522 0 9C0 8.73478 0.105357 8.48043 0.292893 8.29289C0.48043 8.10536 0.734784 8 1 8H4C4.22716 7.99989 4.44759 8.07713 4.625 8.219L9.082 11.785L13.482 9.143C13.709 9.01208 13.9784 8.97553 14.2321 9.04122C14.4859 9.1069 14.7037 9.26957 14.8387 9.49422C14.9737 9.71886 15.0151 9.98753 14.954 10.2424C14.8929 10.4973 14.7342 10.718 14.512 10.857L9.512 13.857C9.35736 13.95 9.18044 13.9994 9 14Z" />
    </svg>
  ),

  chat: (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.30797 0H15.6514C16.3879 0 16.9857 0.597333 16.9857 1.33333V10.6667C16.9857 11.4027 16.3879 12 15.6514 12H8.97968L4.97665 16V12H2.30797C1.57142 12 0.973633 11.4027 0.973633 10.6667V1.33333C0.973633 0.597333 1.57142 0 2.30797 0Z" />
    </svg>
  ),

  check: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.21969 0.468347L3.49994 5.1881L1.78019 3.46835C1.48591 3.18412 1.01813 3.18818 0.728825 3.47748C0.439525 3.76678 0.43546 4.23456 0.719689 4.52885L2.96969 6.77885C3.26256 7.07163 3.73731 7.07163 4.03019 6.77885L9.28019 1.52885C9.56442 1.23456 9.56035 0.766783 9.27105 0.477483C8.98175 0.188182 8.51397 0.184117 8.21969 0.468347Z" />
    </svg>
  ),

  chevronRight: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.29259 1.70757L7.58559 6.00057L3.29259 10.2936C3.11043 10.4822 3.00964 10.7348 3.01192 10.997C3.0142 11.2592 3.11937 11.51 3.30477 11.6954C3.49018 11.8808 3.74099 11.986 4.00319 11.9882C4.26539 11.9905 4.51799 11.8897 4.70659 11.7076L9.70659 6.70757C9.89406 6.52004 9.99938 6.26573 9.99938 6.00057C9.99938 5.7354 9.89406 5.4811 9.70659 5.29357L4.70659 0.293569C4.61435 0.198059 4.504 0.121877 4.382 0.0694675C4.25999 0.0170583 4.12877 -0.0105277 3.99599 -0.0116816C3.86321 -0.0128355 3.73153 0.0124674 3.60864 0.0627479C3.48574 0.113029 3.37409 0.187282 3.2802 0.281175C3.1863 0.375068 3.11205 0.486719 3.06177 0.609615C3.01149 0.732512 2.98619 0.864191 2.98734 0.99697C2.9885 1.12975 3.01608 1.26097 3.06849 1.38297C3.1209 1.50498 3.19708 1.61532 3.29259 1.70757Z" />
    </svg>
  ),

  circleCheck: (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M.687 48C.687 21.873 21.871.69 48 .688c26.13 0 47.313 21.184 47.313 47.314S74.13 95.314 48 95.314C21.87 95.314.687 74.13.687 48ZM48 4.688C24.08 4.69 4.687 24.081 4.687 48.002S24.08 91.314 48 91.314 91.313 71.92 91.313 48 71.921 4.688 48 4.688" />
      <path d="M71.29 30.96a2 2 0 0 1 0 2.83L40.04 65.04a2 2 0 0 1-2.83 0l-12.5-12.5a2 2 0 1 1 2.83-2.83l11.085 11.087L68.461 30.96a2 2 0 0 1 2.828 0Z" />
    </svg>
  ),

  circlePencil: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.6892 12.1104L10.6668 18.1328L9.60008 22.3995L13.8668 21.3328L19.8892 15.3104L16.6892 12.1104Z" />
      <path d="M22.0876 11.6039L20.3959 9.91218C20.1959 9.71221 19.9246 9.59988 19.6418 9.59988C19.3589 9.59988 19.0877 9.71221 18.8876 9.91218L17.4444 11.3554L20.6444 14.5554L22.0876 13.1122C22.2876 12.9122 22.3999 12.6409 22.3999 12.358C22.3999 12.0752 22.2876 11.8039 22.0876 11.6039V11.6039Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      />
    </svg>
  ),

  close: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.7 1.3C14.3 0.9 13.7 0.9 13.3 1.3L8 6.6L2.7 1.3C2.3 0.9 1.7 0.9 1.3 1.3C0.9 1.7 0.9 2.3 1.3 2.7L6.6 8L1.3 13.3C0.9 13.7 0.9 14.3 1.3 14.7C1.5 14.9 1.7 15 2 15C2.3 15 2.5 14.9 2.7 14.7L8 9.4L13.3 14.7C13.5 14.9 13.8 15 14 15C14.2 15 14.5 14.9 14.7 14.7C15.1 14.3 15.1 13.7 14.7 13.3L9.4 8L14.7 2.7C15.1 2.3 15.1 1.7 14.7 1.3Z" />
    </svg>
  ),

  closeSettings: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="16"
        y="16.5"
        width="16"
        height="16"
        rx="8"
        transform="rotate(-180 16 16.5)"
      />
      <path d="M5.14619 10.3065L8.00819 7.58548L10.8702 10.3065C10.9959 10.422 11.1643 10.4858 11.3391 10.4844C11.5139 10.483 11.6811 10.4163 11.8047 10.2988C11.9283 10.1813 11.9985 10.0223 12 9.8561C12.0015 9.68992 11.9343 9.52981 11.8129 9.41027L8.47953 6.24113C8.35451 6.12231 8.18497 6.05556 8.00819 6.05555C7.83142 6.05555 7.66188 6.12231 7.53686 6.24113L4.20353 9.41027C4.13985 9.46874 4.08906 9.53868 4.05412 9.616C4.01919 9.69333 4.00079 9.77651 4.00003 9.86066C3.99926 9.94482 4.01612 10.0283 4.04964 10.1062C4.08317 10.1841 4.13267 10.2548 4.19526 10.3144C4.25786 10.3739 4.33229 10.4209 4.41422 10.4528C4.49615 10.4847 4.58394 10.5007 4.67246 10.5C4.76098 10.4992 4.84846 10.4818 4.9298 10.4485C5.01113 10.4153 5.08469 10.367 5.14619 10.3065Z" />
    </svg>
  ),

  comment: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none">
      <path d="M11.531 0h-10.5c-.45 0-.75.3-.75.75V9c0 .45.3.75.75.75h2.7l2.025 2.025c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225L8.831 9.75h2.7c.45 0 .75-.3.75-.75V.75c0-.45-.3-.75-.75-.75Zm-.75 8.25h-2.25a.68.68 0 0 0-.525.225L6.281 10.2 4.556 8.475a.68.68 0 0 0-.525-.225h-2.25V1.5h9v6.75Z" />
    </svg>
  ),

  compare: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 4L9 8L13 12V9H16V7H13V4Z" />
      <path d="M7 8L3 4V7H0V9H3V12L7 8Z" />
    </svg>
  ),

  copy: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1.33333C12 0.979711 11.8595 0.640573 11.6095 0.390524C11.3594 0.140476 11.0203 0 10.6667 0L1.33333 0C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333L0 12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H6V6C6 5.64638 6.14048 5.30724 6.39052 5.05719C6.64057 4.80714 6.97971 4.66667 7.33333 4.66667H12V1.33333Z" />
      <path d="M15.3333 6.66602H8.66667C8.29848 6.66602 8 6.96449 8 7.33268V15.3327C8 15.7009 8.29848 15.9993 8.66667 15.9993H15.3333C15.7015 15.9993 16 15.7009 16 15.3327V7.33268C16 6.96449 15.7015 6.66602 15.3333 6.66602Z" />
    </svg>
  ),

  dark: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 0C2.5 0.9 0 4.1 0 7.9C0 12.4 3.6 16 8.1 16C11.9 16 15 13.5 16 10C9.9 11.7 4.3 6.1 6 0Z" />
    </svg>
  ),

  dateBlack: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M26 15H25V13C25 12.7348 24.8946 12.4804 24.7071 12.2929C24.5196 12.1054 24.2652 12 24 12C23.7348 12 23.4804 12.1054 23.2929 12.2929C23.1054 12.4804 23 12.7348 23 13V15H17V13C17 12.7348 16.8946 12.4804 16.7071 12.2929C16.5196 12.1054 16.2652 12 16 12C15.7348 12 15.4804 12.1054 15.2929 12.2929C15.1054 12.4804 15 12.7348 15 13V15H14C13.4696 15 12.9609 15.2107 12.5858 15.5858C12.2107 15.9609 12 16.4696 12 17V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V17C28 16.4696 27.7893 15.9609 27.4142 15.5858C27.0391 15.2107 26.5304 15 26 15ZM14 26V19H26V26H14Z" />
      <line x1="17.7443" y1="19" x2="17.7443" y2="26" />
      <line x1="13.3716" y1="18.9045" x2="13.3716" y2="25.9045" />
      <line x1="26.4893" y1="18.9045" x2="26.4893" y2="25.9045" />
      <line x1="22.1167" y1="19" x2="22.1167" y2="26" />
    </svg>
  ),

  dateWithGreenCircle: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M26 15H25V13C25 12.7348 24.8946 12.4804 24.7071 12.2929C24.5196 12.1054 24.2652 12 24 12C23.7348 12 23.4804 12.1054 23.2929 12.2929C23.1054 12.4804 23 12.7348 23 13V15H17V13C17 12.7348 16.8946 12.4804 16.7071 12.2929C16.5196 12.1054 16.2652 12 16 12C15.7348 12 15.4804 12.1054 15.2929 12.2929C15.1054 12.4804 15 12.7348 15 13V15H14C13.4696 15 12.9609 15.2107 12.5858 15.5858C12.2107 15.9609 12 16.4696 12 17V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V17C28 16.4696 27.7893 15.9609 27.4142 15.5858C27.0391 15.2107 26.5304 15 26 15ZM14 26V19H26V26H14Z" />
      <circle cx="22.5" cy="21.5" r="1.5" fill="#B7FF00" />
    </svg>
  ),

  drag: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 6C2 6.82843 2.67157 7.5 3.5 7.5C4.32843 7.5 5 6.82843 5 6C5 5.17157 4.32843 4.5 3.5 4.5C2.67157 4.5 2 5.17157 2 6Z" />
      <path d="M2 10.5C2 11.3284 2.67157 12 3.5 12C4.32843 12 5 11.3284 5 10.5C5 9.67157 4.32843 9 3.5 9C2.67157 9 2 9.67157 2 10.5Z" />
      <path d="M2 1.5C2 2.32843 2.67157 3 3.5 3C4.32843 3 5 2.32843 5 1.5C5 0.671573 4.32843 -2.93554e-08 3.5 -6.55671e-08C2.67157 -1.01779e-07 2 0.671573 2 1.5Z" />
      <path d="M7 6C7 6.82843 7.67157 7.5 8.5 7.5C9.32843 7.5 10 6.82843 10 6C10 5.17157 9.32843 4.5 8.5 4.5C7.67157 4.5 7 5.17157 7 6Z" />
      <path d="M7 10.5C7 11.3284 7.67157 12 8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5Z" />
      <path d="M7 1.5C7 2.32843 7.67157 3 8.5 3C9.32843 3 10 2.32843 10 1.5C10 0.671573 9.32843 -2.93554e-08 8.5 -6.55671e-08C7.67157 -1.01779e-07 7 0.671573 7 1.5Z" />
    </svg>
  ),

  dropdownArrow: (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.29259 1.48876L5.58559 5.23861L1.29259 8.98845C1.11043 9.15319 1.00964 9.37384 1.01192 9.60286C1.0142 9.83188 1.11937 10.051 1.30477 10.2129C1.49018 10.3749 1.74099 10.4667 2.00319 10.4687C2.26539 10.4707 2.51799 10.3827 2.70659 10.2236L7.70659 5.85616C7.89406 5.69236 7.99938 5.47022 7.99938 5.23861C7.99938 5.00699 7.89406 4.78486 7.70659 4.62106L2.70659 0.253662C2.61435 0.170236 2.504 0.103692 2.382 0.0579135C2.25999 0.0121354 2.12877 -0.0119607 1.99599 -0.0129685C1.86321 -0.0139763 1.73153 0.00812482 1.60864 0.0520441C1.48574 0.0959634 1.37409 0.160822 1.2802 0.242835C1.1863 0.324849 1.11205 0.422374 1.06177 0.529721C1.01149 0.637069 0.986188 0.752088 0.987342 0.868068C0.988496 0.984048 1.01608 1.09867 1.06849 1.20523C1.1209 1.3118 1.19708 1.40819 1.29259 1.48876V1.48876Z"
        fill="#121212"
      />
    </svg>
  ),

  expand: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.4999 7C10.5655 7.00027 10.6304 6.98735 10.6909 6.962C10.7824 6.92421 10.8605 6.86013 10.9155 6.77789C10.9705 6.69565 10.9999 6.59894 10.9999 6.5V1.5C10.9999 1.36739 10.9472 1.24022 10.8535 1.14645C10.7597 1.05268 10.6325 1 10.4999 1H5.49992C5.4009 0.999824 5.30405 1.02905 5.22167 1.08398C5.13928 1.13891 5.07505 1.21706 5.03713 1.30854C4.99922 1.40001 4.98931 1.50068 5.00868 1.59779C5.02805 1.6949 5.07581 1.78407 5.14592 1.854L10.1459 6.854C10.1924 6.9004 10.2476 6.93718 10.3084 6.96223C10.3691 6.98728 10.4342 7.00012 10.4999 7Z" />
      <path d="M1.309 5.03796C1.21756 5.07576 1.1394 5.13983 1.08439 5.22207C1.02939 5.30431 1.00002 5.40102 1 5.49996V10.5C1 10.6326 1.05268 10.7597 1.14645 10.8535C1.24021 10.9473 1.36739 11 1.5 11H6.5C6.59902 11.0001 6.69586 10.9709 6.77825 10.916C6.86064 10.8611 6.92487 10.7829 6.96278 10.6914C7.0007 10.6 7.0106 10.4993 6.99124 10.4022C6.97187 10.3051 6.92411 10.2159 6.854 10.146L1.854 5.14596C1.78402 5.07608 1.69489 5.02852 1.59788 5.00929C1.50087 4.99007 1.40034 5.00005 1.309 5.03796Z" />
    </svg>
  ),

  eye: (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 9.35676C7.75705 9.35676 9.51254 7.41319 10.2649 6.28466C10.5784 5.84579 10.5784 5.28153 10.2649 4.84266C9.51254 3.77683 7.75705 1.83325 5.5 1.83325C3.24295 1.83325 1.48746 3.77683 0.73511 4.90535C0.42163 5.34422 0.42163 5.90849 0.73511 6.28466C1.48746 7.41319 3.24295 9.35676 5.5 9.35676ZM5.5 3.71413C6.56583 3.71413 7.38088 4.52918 7.38088 5.59501C7.38088 6.66084 6.56583 7.47588 5.5 7.47588C4.43417 7.47588 3.61912 6.66084 3.61912 5.59501C3.61912 4.52918 4.43417 3.71413 5.5 3.71413Z" />
    </svg>
  ),

  eyeDisabled: (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 3.5L4.5 8.625C4.8125 8.6875 5.1875 8.75 5.5 8.75C7.75 8.75 9.5 6.8125 10.25 5.6875C10.5625 5.25 10.5625 4.6875 10.25 4.25C10.125 4.0625 9.875 3.8125 9.625 3.5Z"
        fill="#CCCCCC"
      />
      <path
        d="M9.4375 0.1875L7.75 1.875C7.0625 1.5 6.3125 1.25 5.5 1.25C3.25 1.25 1.5 3.1875 0.75 4.3125C0.4375 4.75 0.4375 5.3125 0.75 5.6875C1.0625 6.1875 1.625 6.8125 2.25 7.375L0.6875 8.9375C0.4375 9.1875 0.4375 9.5625 0.6875 9.8125C0.8125 9.9375 0.9375 10 1.125 10C1.3125 10 1.4375 9.9375 1.5625 9.8125L10.3125 1.0625C10.5625 0.8125 10.5625 0.4375 10.3125 0.1875C10.0625 -0.0625 9.6875 -0.0625 9.4375 0.1875ZM3.8125 5.8125C3.6875 5.5625 3.625 5.3125 3.625 5C3.625 3.9375 4.4375 3.125 5.5 3.125C5.8125 3.125 6.0625 3.1875 6.3125 3.3125L3.8125 5.8125Z"
        fill="#CCCCCC"
      />
    </svg>
  ),

  filter: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_97_3027)">
        <path d="M11 1H1C0.734784 1 0.48043 1.10536 0.292893 1.29289C0.105357 1.48043 0 1.73478 0 2C0 2.26522 0.105357 2.51957 0.292893 2.70711C0.48043 2.89464 0.734784 3 1 3H11C11.2652 3 11.5196 2.89464 11.7071 2.70711C11.8946 2.51957 12 2.26522 12 2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1Z" />
        <path d="M9 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6C2 6.26522 2.10536 6.51957 2.29289 6.70711C2.48043 6.89464 2.73478 7 3 7H9C9.26522 7 9.51957 6.89464 9.70711 6.70711C9.89464 6.51957 10 6.26522 10 6C10 5.73478 9.89464 5.48043 9.70711 5.29289C9.51957 5.10536 9.26522 5 9 5Z" />
        <path d="M7 9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H7C7.26522 11 7.51957 10.8946 7.70711 10.7071C7.89464 10.5196 8 10.2652 8 10C8 9.73478 7.89464 9.48043 7.70711 9.29289C7.51957 9.10536 7.26522 9 7 9Z" />
      </g>
      <defs>
        <clipPath id="clip0_97_3027">
          <rect width="12" height="12" />
        </clipPath>
      </defs>
    </svg>
  ),

  fromTo: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5202 17.2867C21.7154 17.0914 21.7154 16.7748 21.5202 16.5796L18.3382 13.3976C18.1429 13.2023 17.8264 13.2023 17.6311 13.3976C17.4358 13.5928 17.4358 13.9094 17.6311 14.1047L20.4595 16.9331L17.6311 19.7615C17.4358 19.9568 17.4358 20.2734 17.6311 20.4686C17.8264 20.6639 18.1429 20.6639 18.3382 20.4686L21.5202 17.2867ZM3.91663 17.4331L21.1666 17.4331L21.1666 16.4331L3.91663 16.4331L3.91663 17.4331Z"
        fill="#9A9A9A"
      />
      <path
        d="M3.47982 7.7131C3.28456 7.90836 3.28456 8.22494 3.47982 8.4202L6.6618 11.6022C6.85706 11.7974 7.17365 11.7974 7.36891 11.6022C7.56417 11.4069 7.56417 11.0903 7.36891 10.8951L4.54048 8.06665L7.36891 5.23822C7.56417 5.04296 7.56417 4.72638 7.36891 4.53112C7.17365 4.33585 6.85706 4.33585 6.6618 4.53112L3.47982 7.7131ZM21.0834 7.56665L3.83337 7.56665L3.83337 8.56665L21.0834 8.56665L21.0834 7.56665Z"
        fill="#9A9A9A"
      />
    </svg>
  ),

  gain: (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="4.5"
        cy="4.5"
        rx="4.5"
        ry="4.5"
        transform="rotate(-180 4.5 4.5)"
        fillOpacity="0.2"
      />
      <path d="M2.02669 5.58141C2.04476 5.60727 2.07112 5.62881 2.10305 5.6438C2.13498 5.6588 2.17133 5.66672 2.20836 5.66675L6.79169 5.66675C6.82873 5.66678 6.86511 5.65891 6.89709 5.64395C6.92906 5.62899 6.95547 5.60748 6.9736 5.58164C6.99172 5.55579 7.00091 5.52655 7.00021 5.49693C6.99951 5.4673 6.98894 5.43836 6.96961 5.41308L4.67794 2.41308C4.65935 2.38867 4.63322 2.36849 4.60206 2.35448C4.5709 2.34048 4.53576 2.33313 4.50002 2.33313C4.46429 2.33313 4.42915 2.34048 4.39799 2.35448C4.36683 2.36849 4.3407 2.38867 4.32211 2.41308L2.03044 5.41308C2.01119 5.43835 2.0007 5.46726 2.00004 5.49684C1.99938 5.52642 2.00858 5.55562 2.02669 5.58141Z" />
    </svg>
  ),

  gift: (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5.92318V17.8398M9 5.92318C9 5.92318 9 4.5548 9 4.08984C9 3.07732 9.82081 2.25651 10.8333 2.25651C11.8459 2.25651 12.6667 3.07732 12.6667 4.08984C12.6667 5.10237 11.8459 5.92318 10.8333 5.92318C10.2858 5.92318 9 5.92318 9 5.92318ZM9 5.92318C9 5.92318 9 4.14751 9 3.63151C9 2.36586 7.97399 1.33984 6.70833 1.33984C5.44268 1.33984 4.41667 2.36586 4.41667 3.63151C4.41667 4.89716 5.44268 5.92318 6.70833 5.92318C7.45798 5.92318 9 5.92318 9 5.92318ZM2.58333 9.58984H15.4167M2.58333 9.58984C1.57081 9.58984 0.75 8.76903 0.75 7.75651C0.75 6.74399 1.57081 5.92318 2.58333 5.92318H15.4167C16.4292 5.92318 17.25 6.74399 17.25 7.75651C17.25 8.76903 16.4292 9.58984 15.4167 9.58984M2.58333 9.58984L2.58333 16.0065C2.58333 17.019 3.40414 17.8398 4.41667 17.8398H13.5833C14.5959 17.8398 15.4167 17.019 15.4167 16.0065V9.58984"
        stroke="#111827"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  heart: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none">
      <path d="M5.831 11.625c-.6-.525-5.55-4.65-5.55-7.8a3.6 3.6 0 0 1 3.6-3.6c.9 0 1.725.375 2.4.9.675-.6 1.5-.9 2.4-.9a3.6 3.6 0 0 1 3.6 3.6c0 3.15-4.95 7.275-5.55 7.725-.225.3-.675.3-.9.075Zm-1.95-9.9c-1.125 0-2.1.975-2.1 2.1 0 1.65 2.625 4.5 4.5 6.15 1.575-1.425 4.5-4.35 4.5-6.15 0-1.2-.975-2.1-2.1-2.1-.675 0-1.35.375-1.725.975a.77.77 0 0 1-1.275 0c-.45-.6-1.05-.975-1.8-.975Z" />
    </svg>
  ),

  info: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z" />
      <path d="M9 7H7V12H9V7Z" />
      <path d="M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z" />
    </svg>
  ),

  light: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 0H7V2H9V0Z" fill="#B7FF00" />
      <path d="M14.2937 3.05152L12.8799 1.63672L11.4651 3.05052L12.8789 4.46532L14.2937 3.05152Z" />
      <path d="M16 7H14V9H16V7Z" fill="#B7FF00" />
      <path d="M11.5354 13.0198L12.9502 14.4336L14.364 13.0188L12.9492 11.605L11.5354 13.0198Z" />
      <path d="M9 14H7V16H9V14Z" fill="#B7FF00" />
      <path d="M1.56569 12.9485L2.97949 14.3633L4.39429 12.9495L2.98049 11.5347L1.56569 12.9485Z" />
      <path d="M2 7H0V9H2V7Z" fill="#B7FF00" />
      <path d="M4.4646 3.12083L3.0498 1.70703L1.636 3.12183L3.0508 4.53563L4.4646 3.12083Z" />
      <path d="M8 4C5.8 4 4 5.8 4 8C4 10.2 5.8 12 8 12C10.2 12 12 10.2 12 8C12 5.8 10.2 4 8 4Z" />
    </svg>
  ),

  lock: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330">
      <path d="M65 330h200c8.284 0 15-6.716 15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85S80 38.131 80 85v45H65c-8.284 0-15 6.716-15 15v170c0 8.284 6.716 15 15 15zm115-95.014V255c0 8.284-6.716 15-15 15s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986 0-13.785 11.215-25 25-25s25 11.215 25 25c0 8.162-3.932 15.421-10 19.986zM110 85c0-30.327 24.673-55 55-55s55 24.673 55 55v45H110V85z" />
    </svg>
  ),

  loss: (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="4.5"
        cy="4.5"
        rx="4.5"
        ry="4.5"
        transform="rotate(-180 4.5 4.5)"
        fillOpacity="0.2"
      />
      <path d="M6.97331 3.41859C6.95524 3.39273 6.92888 3.37119 6.89695 3.3562C6.86502 3.3412 6.82867 3.33328 6.79164 3.33325L2.20831 3.33325C2.17127 3.33322 2.13489 3.34109 2.10291 3.35605C2.07094 3.37101 2.04453 3.39252 2.0264 3.41836C2.00828 3.44421 1.99909 3.47345 1.99979 3.50307C2.00049 3.5327 2.01106 3.56164 2.03039 3.58692L4.32206 6.58692C4.34065 6.61133 4.36678 6.63151 4.39794 6.64552C4.4291 6.65952 4.46424 6.66687 4.49998 6.66687C4.53571 6.66687 4.57085 6.65952 4.60201 6.64552C4.63317 6.63151 4.6593 6.61133 4.67789 6.58692L6.96956 3.58692C6.98881 3.56165 6.9993 3.53274 6.99996 3.50316C7.00062 3.47358 6.99142 3.44438 6.97331 3.41859Z" />
    </svg>
  ),

  mark: (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2934 0.293407L4.00041 6.58641L1.70741 4.29341C1.5188 4.11125 1.2662 4.01045 1.00401 4.01273C0.741809 4.01501 0.490997 4.12018 0.305589 4.30559C0.12018 4.491 0.0150115 4.74181 0.0127331 5.00401C0.0104547 5.2662 0.111249 5.51881 0.293407 5.70741L3.29341 8.70741C3.48093 8.89488 3.73524 9.00019 4.00041 9.00019C4.26557 9.00019 4.51988 8.89488 4.70741 8.70741L11.7074 1.70741C11.8896 1.5188 11.9904 1.2662 11.9881 1.00401C11.9858 0.741809 11.8806 0.490997 11.6952 0.305588C11.5098 0.12018 11.259 0.0150115 10.9968 0.0127331C10.7346 0.0104547 10.482 0.111249 10.2934 0.293407Z"
        fill="#121212"
      />
    </svg>
  ),

  marker: (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.09887 0.872958C3.46225 0.117698 4.53775 0.117697 4.90113 0.872957L7.64041 6.56644C7.95983 7.23035 7.47603 8 6.73928 8H1.26072C0.523971 8 0.0401713 7.23035 0.359592 6.56644L3.09887 0.872958Z" />
    </svg>
  ),

  merge: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 0H5V5H0V16H11V11H16V0ZM9 14H2V7H5V11H9V14ZM14 9H11V5H7V2H14V9Z" />
    </svg>
  ),

  merlinLogo: (
    <svg
      width="99"
      height="19"
      viewBox="0 0 99 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M34.3047 18.215V0H36.3555L43.2558 14.5074L50.1176 0H52.1992V18.2073H50.0559V4.94605L43.8572 18.215H42.6544L36.448 4.94605V18.215H34.3047Z" />
      <path d="M66.0306 7.82955C65.5449 6.66034 64.8201 5.75267 63.8487 5.12191C62.8773 4.49116 61.7054 4.17578 60.333 4.17578C59.0069 4.17578 57.8504 4.47577 56.8636 5.06807C55.8767 5.66036 55.1135 6.5065 54.5583 7.59878C54.0109 8.69107 53.7334 9.98334 53.7334 11.4756C53.7334 12.8987 54.0109 14.1448 54.5738 15.214C55.1289 16.2832 55.9153 17.114 56.9098 17.7063C57.9044 18.2985 59.084 18.5985 60.4255 18.5985C61.7516 18.5985 62.9544 18.2678 64.0183 17.6063C65.09 16.9447 65.8841 16.014 66.4238 14.8063L64.2573 14.0602C63.8795 14.8371 63.3553 15.4294 62.6845 15.8448C62.0138 16.2601 61.2274 16.4678 60.3253 16.4678C58.9838 16.4678 57.943 16.0217 57.2182 15.1371C56.586 14.3679 56.2314 13.3371 56.1466 12.0218H66.6474C66.7245 10.3987 66.5163 8.99875 66.0306 7.82955ZM56.2005 10.2064C56.3393 9.09875 56.6786 8.20646 57.226 7.53725C57.9507 6.64496 59.0146 6.19881 60.4101 6.19881C61.7131 6.19881 62.6922 6.61419 63.3553 7.44494C63.8795 8.09877 64.2033 9.02183 64.3267 10.2064H56.2005Z" />
      <path d="M75.2742 4.55393V6.66927C74.8039 6.5462 74.2796 6.50774 73.7168 6.56927C73.154 6.63081 72.6297 6.8385 72.144 7.18464C71.7046 7.50002 71.3653 7.87694 71.1263 8.32308C70.8873 8.76923 70.7177 9.25383 70.6252 9.7692C70.5327 10.2846 70.4864 10.8153 70.4864 11.3538V18.2075H68.2197V4.55393H70.2397V6.72312C70.3322 6.56158 70.4324 6.40774 70.5404 6.26159C70.7948 5.90775 71.0878 5.61545 71.4116 5.39238C71.7662 5.10777 72.1672 4.88469 72.6143 4.73854C73.0615 4.5847 73.5164 4.4924 73.9867 4.46932C74.4338 4.43086 74.8656 4.46163 75.2742 4.55393Z" />
      <path d="M76.8154 18.215V0H79.0744V18.215H76.8154Z" />
      <path d="M81.3867 2.2538V0H83.6457V2.2538H81.3867ZM81.3867 18.215V4.55375H83.6457V18.215H81.3867Z" />
      <path d="M98.0018 10.6605V18.2142H95.7196V11.3682C95.7196 10.722 95.6657 10.099 95.55 9.49898C95.4344 8.899 95.2339 8.36055 94.9564 7.88363C94.6711 7.40672 94.2933 7.02981 93.8153 6.75289C93.3373 6.47597 92.7359 6.33751 92.0112 6.33751C91.4484 6.33751 90.9318 6.42982 90.4692 6.62212C90.0067 6.81443 89.6135 7.09904 89.2819 7.49133C88.9504 7.87594 88.696 8.36824 88.5109 8.95284C88.3336 9.53744 88.2411 10.2297 88.2411 11.022V18.2219H85.959V4.55294H87.9867V6.31444C88.3953 5.7606 88.8964 5.31446 89.4901 4.96062C90.3536 4.45294 91.379 4.19141 92.5509 4.19141C93.4375 4.19141 94.1931 4.32986 94.8176 4.60678C95.4421 4.8837 95.9587 5.25292 96.375 5.71445C96.7913 6.17598 97.1151 6.69135 97.3541 7.26057C97.5931 7.82979 97.755 8.4067 97.8553 8.9913C97.9555 9.5836 98.0018 10.1451 98.0018 10.6605Z" />
      <path d="M27.4266 3.70214C25.1445 4.06367 24.5817 4.6252 24.2116 6.90977C24.1808 7.10207 23.9109 7.10207 23.8801 6.90977C23.5177 4.63289 22.9549 4.07137 20.6651 3.70214C20.4723 3.67137 20.4723 3.40215 20.6651 3.37138C22.9472 3.00985 23.51 2.44832 23.8801 0.163759C23.9109 -0.0285446 24.1808 -0.0285446 24.2116 0.163759C24.574 2.44063 25.1368 3.00216 27.4266 3.37138C27.6116 3.40215 27.6116 3.67137 27.4266 3.70214Z" />
      <path d="M2.97866 17.7548C2.31561 18.3625 1.28249 18.3779 0.604025 17.7856C-0.174669 17.101 -0.197798 15.9164 0.519217 15.201C0.719673 15.001 0.958678 14.8549 1.2131 14.7702C2.0766 14.4856 2.87843 14.0318 3.53376 13.401L17.6119 0.132107C17.7661 -0.0140432 18.0128 -0.0140432 18.167 0.1398C18.2441 0.216721 18.2827 0.316719 18.2827 0.416717C18.2827 0.516714 18.2441 0.616712 18.1747 0.693634L4.86757 14.6702C4.23536 15.3164 3.74193 16.0933 3.4798 16.9548C3.39499 17.2548 3.22537 17.5317 2.97866 17.7548Z" />
    </svg>
  ),

  move: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 8C2 9.10457 2.89543 10 4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8Z" />
      <path d="M2 14C2 15.1046 2.89543 16 4 16C5.10457 16 6 15.1046 6 14C6 12.8954 5.10457 12 4 12C2.89543 12 2 12.8954 2 14Z" />
      <path d="M2 2C2 3.10457 2.89543 4 4 4C5.10457 4 6 3.10457 6 2C6 0.89543 5.10457 -3.91405e-08 4 -8.74228e-08C2.89543 -1.35705e-07 2 0.89543 2 2Z" />
      <path d="M10 8C10 9.10457 10.8954 10 12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8Z" />
      <path d="M10 14C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14Z" />
      <path d="M10 2C10 3.10457 10.8954 4 12 4C13.1046 4 14 3.10457 14 2C14 0.89543 13.1046 -3.91405e-08 12 -8.74228e-08C10.8954 -1.35705e-07 10 0.89543 10 2Z" />
    </svg>
  ),

  navigateBefore: (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.70692 10.7807L2.41392 6.48771L6.70692 2.19471C6.88908 2.00611 6.98987 1.75351 6.98759 1.49131C6.98531 1.22911 6.88015 0.978301 6.69474 0.792893C6.50933 0.607485 6.25852 0.502316 5.99632 0.500038C5.73412 0.497759 5.48152 0.598554 5.29292 0.780712L0.292919 5.78071C0.105448 5.96824 0.000132311 6.22255 0.000132299 6.48771C0.000132287 6.75288 0.105448 7.00718 0.292919 7.19471L5.29292 12.1947C5.38517 12.2902 5.49551 12.3664 5.61751 12.4188C5.73952 12.4712 5.87074 12.4988 6.00352 12.5C6.1363 12.5011 6.26798 12.4758 6.39087 12.4255C6.51377 12.3753 6.62542 12.301 6.71931 12.2071C6.81321 12.1132 6.88746 12.0016 6.93774 11.8787C6.98802 11.7558 7.01332 11.6241 7.01217 11.4913C7.01101 11.3585 6.98343 11.2273 6.93102 11.1053C6.87861 10.9833 6.80243 10.873 6.70692 10.7807Z"
        fill="#9A9A9A"
      />
    </svg>
  ),

  navigateNext: (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.29308 2.19487L7.58608 6.48787L3.29308 10.7809C3.11092 10.9695 3.01013 11.2221 3.01241 11.4843C3.01469 11.7465 3.11985 11.9973 3.30526 12.1827C3.49067 12.3681 3.74148 12.4733 4.00368 12.4755C4.26588 12.4778 4.51848 12.377 4.70708 12.1949L9.70708 7.19487C9.89455 7.00735 9.99987 6.75304 9.99987 6.48787C9.99987 6.22271 9.89455 5.9684 9.70708 5.78087L4.70708 0.780874C4.61483 0.685364 4.50449 0.609181 4.38248 0.556772C4.26048 0.504363 4.12926 0.476777 3.99648 0.475623C3.8637 0.474469 3.73202 0.499772 3.60913 0.550053C3.48623 0.600333 3.37458 0.674586 3.28069 0.768479C3.18679 0.862372 3.11254 0.974024 3.06226 1.09692C3.01198 1.21982 2.98668 1.3515 2.98783 1.48427C2.98898 1.61705 3.01657 1.74827 3.06898 1.87028C3.12139 1.99228 3.19757 2.10263 3.29308 2.19487Z"
        fill="#9A9A9A"
      />
    </svg>
  ),

  openInNew: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z" />
    </svg>
  ),

  options: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8Z" />
      <path d="M6 2C6 3.10457 6.89543 4 8 4C9.10457 4 10 3.10457 10 2C10 0.89543 9.10457 -3.91405e-08 8 -8.74228e-08C6.89543 -1.35705e-07 6 0.89543 6 2Z" />
      <path d="M6 14C6 15.1046 6.89543 16 8 16C9.10457 16 10 15.1046 10 14C10 12.8954 9.10457 12 8 12C6.89543 12 6 12.8954 6 14Z" />
    </svg>
  ),

  overlap: (
    <svg
      className="ml-3"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 0H5V5H0V16H11V11H16V0ZM9 14H2V7H5V11H9V14ZM14 9H11V5H7V2H14V9Z" />
    </svg>
  ),

  plus: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.6667 6.66667H9.33333V1.33333C9.33333 0.979711 9.19286 0.640573 8.94281 0.390524C8.69276 0.140476 8.35362 0 8 0C7.64638 0 7.30724 0.140476 7.05719 0.390524C6.80714 0.640573 6.66667 0.979711 6.66667 1.33333V6.66667H1.33333C0.979711 6.66667 0.640573 6.80714 0.390524 7.05719C0.140476 7.30724 0 7.64638 0 8C0 8.35362 0.140476 8.69276 0.390524 8.94281C0.640573 9.19286 0.979711 9.33333 1.33333 9.33333H6.66667V14.6667C6.66667 15.0203 6.80714 15.3594 7.05719 15.6095C7.30724 15.8595 7.64638 16 8 16C8.35362 16 8.69276 15.8595 8.94281 15.6095C9.19286 15.3594 9.33333 15.0203 9.33333 14.6667V9.33333H14.6667C15.0203 9.33333 15.3594 9.19286 15.6095 8.94281C15.8595 8.69276 16 8.35362 16 8C16 7.64638 15.8595 7.30724 15.6095 7.05719C15.3594 6.80714 15.0203 6.66667 14.6667 6.66667Z" />
    </svg>
  ),

  plusButton: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="15" height="15" rx="5" fill="#EAEAEA" />
      <path d="M10.4167 6.91667H8.08333V4.58333C8.08333 4.42862 8.02187 4.28025 7.91248 4.17085C7.80308 4.06146 7.65471 4 7.5 4C7.34529 4 7.19692 4.06146 7.08752 4.17085C6.97812 4.28025 6.91667 4.42862 6.91667 4.58333V6.91667H4.58333C4.42862 6.91667 4.28025 6.97812 4.17085 7.08752C4.06146 7.19692 4 7.34529 4 7.5C4 7.65471 4.06146 7.80308 4.17085 7.91248C4.28025 8.02187 4.42862 8.08333 4.58333 8.08333H6.91667V10.4167C6.91667 10.5714 6.97812 10.7197 7.08752 10.8291C7.19692 10.9385 7.34529 11 7.5 11C7.65471 11 7.80308 10.9385 7.91248 10.8291C8.02187 10.7197 8.08333 10.5714 8.08333 10.4167V8.08333H10.4167C10.5714 8.08333 10.7197 8.02187 10.8291 7.91248C10.9385 7.80308 11 7.65471 11 7.5C11 7.34529 10.9385 7.19692 10.8291 7.08752C10.7197 6.97812 10.5714 6.91667 10.4167 6.91667Z" />
    </svg>
  ),
  request: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16079_25117)">
        <path d="M13 16H1C0.447 16 0 15.552 0 15V3C0 2.448 0.447 2 1 2H8V4H2V14H12V8H14V15C14 15.552 13.553 16 13 16Z" />
        <path d="M16 2H14V0H12V2H10V4H12V6H14V4H16V2Z" />
      </g>
      <defs>
        <clipPath id="clip0_16079_25117">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  ),
  resize: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5009 7C10.5665 7.00027 10.6314 6.98735 10.6919 6.962C10.7833 6.92421 10.8615 6.86013 10.9165 6.77789C10.9715 6.69565 11.0009 6.59894 11.0009 6.5V1.5C11.0009 1.36739 10.9482 1.24022 10.8544 1.14645C10.7607 1.05268 10.6335 1 10.5009 1H5.50089C5.40187 0.999824 5.30503 1.02905 5.22264 1.08398C5.14025 1.13891 5.07603 1.21706 5.03811 1.30854C5.00019 1.40001 4.99029 1.50068 5.00966 1.59779C5.02902 1.6949 5.07679 1.78407 5.14689 1.854L10.1469 6.854C10.1934 6.9004 10.2486 6.93718 10.3094 6.96223C10.3701 6.98728 10.4352 7.00012 10.5009 7V7Z" />
      <path d="M1.309 5.0382C1.21756 5.076 1.1394 5.14007 1.08439 5.22231C1.02939 5.30455 1.00002 5.40126 1 5.5002V10.5002C1 10.6328 1.05268 10.76 1.14645 10.8538C1.24021 10.9475 1.36739 11.0002 1.5 11.0002H6.5C6.59902 11.0004 6.69586 10.9712 6.77825 10.9162C6.86064 10.8613 6.92487 10.7831 6.96278 10.6917C7.0007 10.6002 7.0106 10.4995 6.99124 10.4024C6.97187 10.3053 6.92411 10.2161 6.854 10.1462L1.854 5.1462C1.78402 5.07632 1.69489 5.02876 1.59788 5.00954C1.50087 4.99031 1.40034 5.00029 1.309 5.0382V5.0382Z" />
    </svg>
  ),
  retweet: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.75 9.75L3 9.75L3 3L4.5 3L2.25 -1.96701e-07L-1.31134e-07 3L1.5 3L1.5 10.5C1.5 10.9145 1.83545 11.25 2.25 11.25L6.75 11.25L6.75 9.75Z" />
      <path d="M6 2.25L9.75 2.25L9.75 9L8.25 9L10.5 12L12.75 9L11.25 9L11.25 1.5C11.25 1.08545 10.9145 0.75 10.5 0.75L6 0.75L6 2.25Z" />
    </svg>
  ),

  question1: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 95.3125C75.0254 95.3125 95.3125 75.0254 95.3125 50C95.3125 24.9746 75.0254 4.6875 50 4.6875C24.9746 4.6875 4.6875 24.9746 4.6875 50C4.6875 75.0254 24.9746 95.3125 50 95.3125Z"
        stroke="#121212"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M50 75C50.8629 75 51.5625 74.3004 51.5625 73.4375C51.5625 72.5746 50.8629 71.875 50 71.875C49.1371 71.875 48.4375 72.5746 48.4375 73.4375C48.4375 74.3004 49.1371 75 50 75Z"
        stroke="#B7FF00"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M39.0625 25.8609C47.6266 22.0719 58.7109 22.5234 62.5 28.6531C66.2891 34.7828 63.6687 41.9078 57.1875 47.4031C50.7062 52.8984 50 56.6125 50 60.9375"
        stroke="#B7FF00"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),

  reddit: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1200 1200">
      <defs></defs>
      <circle fill="#dc4711" cx="600" cy="600" r="500" />
      <path
        fill="#fff"
        d="M933.25,600c0-40.27-32.65-72.92-72.92-72.92-19.66,0-37.46,7.82-50.57,20.46-49.84-35.97-118.51-59.2-195-61.87l33.22-156.27,108.52,23.07c1.32,27.59,23.92,49.61,51.83,49.61s52.08-23.32,52.08-52.08-23.32-52.08-52.08-52.08c-20.46,0-37.99,11.91-46.5,29.07l-121.18-25.76c-3.37-.73-6.9-.07-9.8,1.82-2.9,1.88-4.93,4.84-5.65,8.21l-37.09,174.37c-77.61,2.15-147.38,25.41-197.86,61.78-13.1-12.57-30.84-20.33-50.43-20.33-40.27,0-72.92,32.65-72.92,72.92,0,29.63,17.7,55.08,43.08,66.49-1.12,7.25-1.74,14.6-1.74,22.05,0,112.18,130.58,203.13,291.67,203.13s291.67-90.94,291.67-203.13c0-7.41-.6-14.71-1.71-21.91,25.54-11.34,43.38-36.88,43.38-66.63Zm-499.92,52.09c0-28.72,23.37-52.09,52.11-52.09s52.06,23.37,52.06,52.09-23.36,52.07-52.06,52.07-52.11-23.36-52.11-52.07Zm290.42,137.62c-35.55,35.5-103.66,38.26-123.69,38.26s-88.16-2.76-123.66-38.27c-5.27-5.27-5.27-13.82,0-19.09,5.27-5.27,13.82-5.27,19.09,0,22.4,22.41,70.33,30.36,104.57,30.36s82.18-7.95,104.62-30.37c5.28-5.26,13.82-5.26,19.09,.01,5.27,5.27,5.26,13.82-.01,19.09Zm-9.17-85.54c-28.72,0-52.08-23.36-52.08-52.08s23.37-52.1,52.08-52.1,52.08,23.37,52.08,52.1-23.37,52.08-52.08,52.08Z"
      />
    </svg>
  ),

  remove: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.06595 0H4.07535V2H1.0824V4H11.0589V2H8.06595V0Z"
        fill="#121212"
      />
      <path
        d="M8.06598 10H4.07538V6H2.08008V11C2.08008 11.2652 2.18519 11.5196 2.37228 11.7071C2.55938 11.8946 2.81313 12 3.07773 12H9.06363C9.32822 12 9.58198 11.8946 9.76907 11.7071C9.95617 11.5196 10.0613 11.2652 10.0613 11V6H8.06598V10Z"
        fill="#121212"
      />
    </svg>
  ),

  search: (
    <svg
      width="16"
      height="16"
      viewBox="-2 -3 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.525 8.42236C10.2 7.52795 10.575 6.48447 10.575 5.29193C10.575 2.38509 8.25 0 5.325 0C2.4 0 0 2.38509 0 5.29193C0 8.19876 2.4 10.5839 5.325 10.5839C6.525 10.5839 7.65 10.2112 8.475 9.54037L10.725 11.7764C10.875 11.9255 11.1 12 11.25 12C11.4 12 11.625 11.9255 11.775 11.7764C12.075 11.4783 12.075 11.0311 11.775 10.7329L9.525 8.42236ZM5.325 9.01863C3.225 9.01863 1.5 7.37888 1.5 5.29193C1.5 3.20497 3.225 1.49068 5.325 1.49068C7.425 1.49068 9.15 3.20497 9.15 5.29193C9.15 7.37888 7.425 9.01863 5.325 9.01863Z" />
    </svg>
  ),

  send: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.854 0.146349C11.7867 0.079015 11.7015 0.0323259 11.6085 0.0117756C11.5155 -0.00877458 11.4185 -0.00233079 11.329 0.0303487L0.329044 4.03035C0.233896 4.06497 0.1515 4.12766 0.0927566 4.21012C0.0340131 4.29259 0.00169036 4.39095 6.4496e-05 4.49219C-0.00156137 4.59342 0.0275863 4.69277 0.0836513 4.77708C0.139716 4.86139 0.220057 4.92669 0.314044 4.96435L5.11404 6.88535L7.03504 11.6853C7.0721 11.7784 7.13623 11.8581 7.21914 11.9143C7.30204 11.9705 7.3999 12.0004 7.50004 12.0003H7.50804C7.60931 11.9988 7.70771 11.9664 7.79021 11.9077C7.87271 11.8489 7.93542 11.7665 7.97004 11.6713L11.97 0.671349C12.0027 0.581879 12.0092 0.484937 11.9886 0.39193C11.9681 0.298922 11.9214 0.21372 11.854 0.146349V0.146349Z" />
    </svg>
  ),

  settings: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_626_30570)">
        <path d="M11.555 4.99999L10.069 4.83499C9.98026 4.52415 9.85612 4.22452 9.69901 3.94199L10.633 2.77399C10.7099 2.67789 10.7486 2.55681 10.7418 2.43392C10.735 2.31104 10.6831 2.19499 10.596 2.10799L9.88901 1.39999C9.80201 1.31294 9.68596 1.26103 9.56308 1.25421C9.4402 1.24738 9.31911 1.28611 9.22301 1.36299L8.05501 2.29999C7.77249 2.14289 7.47286 2.01874 7.16201 1.92999L7.00001 0.444994C6.98641 0.322134 6.92779 0.208665 6.83546 0.126486C6.74312 0.0443072 6.62362 -0.000755911 6.50001 -6.04878e-06H5.50001C5.3764 -0.000755911 5.2569 0.0443072 5.16456 0.126486C5.07223 0.208665 5.0136 0.322134 5.00001 0.444994L4.83801 1.93099C4.52716 2.01974 4.22753 2.14389 3.94501 2.30099L2.77701 1.36699C2.6809 1.29011 2.55982 1.25138 2.43694 1.25821C2.31406 1.26503 2.19801 1.31694 2.11101 1.40399L1.40001 2.11099C1.31296 2.19799 1.26105 2.31404 1.25422 2.43692C1.2474 2.55981 1.28613 2.68089 1.36301 2.77699L2.30001 3.94499C2.1429 4.22752 2.01876 4.52715 1.93001 4.83799L0.445009 4.99999C0.32215 5.01359 0.20868 5.07221 0.126501 5.16455C0.0443225 5.25688 -0.000740652 5.37639 9.21001e-06 5.49999V6.49999C-0.000740652 6.6236 0.0443225 6.7431 0.126501 6.83544C0.20868 6.92778 0.32215 6.9864 0.445009 6.99999L1.93101 7.16499C2.01976 7.47584 2.1439 7.77547 2.30101 8.05799L1.36701 9.22299C1.29013 9.3191 1.2514 9.44018 1.25822 9.56307C1.26505 9.68595 1.31696 9.802 1.40401 9.88899L2.11101 10.596C2.19801 10.683 2.31406 10.735 2.43694 10.7418C2.55982 10.7486 2.6809 10.7099 2.77701 10.633L3.94501 9.69999C4.22753 9.8571 4.52716 9.98125 4.83801 10.07L5.00001 11.555C5.0136 11.6779 5.07223 11.7913 5.16456 11.8735C5.2569 11.9557 5.3764 12.0007 5.50001 12H6.50001C6.62362 12.0007 6.74312 11.9557 6.83546 11.8735C6.92779 11.7913 6.98641 11.6779 7.00001 11.555L7.16501 10.069C7.47586 9.98025 7.77549 9.8561 8.05801 9.69899L9.22601 10.633C9.32211 10.7099 9.4432 10.7486 9.56608 10.7418C9.68896 10.735 9.80501 10.683 9.89201 10.596L10.599 9.88899C10.6861 9.802 10.738 9.68595 10.7448 9.56307C10.7516 9.44018 10.7129 9.3191 10.636 9.22299L9.70001 8.05499C9.85712 7.77247 9.98126 7.47284 10.07 7.16199L11.555 6.99999C11.6779 6.9864 11.7913 6.92778 11.8735 6.83544C11.9557 6.7431 12.0008 6.6236 12 6.49999V5.49999C12.0008 5.37639 11.9557 5.25688 11.8735 5.16455C11.7913 5.07221 11.6779 5.01359 11.555 4.99999ZM6.00001 7.99999C5.60445 7.99999 5.21777 7.8827 4.88887 7.66293C4.55997 7.44317 4.30363 7.13081 4.15225 6.76536C4.00087 6.39991 3.96127 5.99778 4.03844 5.60981C4.11561 5.22185 4.30609 4.86549 4.5858 4.58578C4.8655 4.30608 5.22187 4.11559 5.60983 4.03842C5.99779 3.96125 6.39992 4.00086 6.76538 4.15223C7.13083 4.30361 7.44319 4.55996 7.66295 4.88885C7.88271 5.21775 8.00001 5.60443 8.00001 5.99999C8.00001 6.53043 7.7893 7.03913 7.41422 7.41421C7.03915 7.78928 6.53044 7.99999 6.00001 7.99999Z" />
      </g>
      <defs>
        <clipPath id="clip0_626_30570">
          <rect width="12" height="12" />
        </clipPath>
      </defs>
    </svg>
  ),

  sortDown: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.64645 11.3536C6.84171 11.5488 7.15829 11.5488 7.35355 11.3536L10.5355 8.17157C10.7308 7.97631 10.7308 7.65973 10.5355 7.46447C10.3403 7.2692 10.0237 7.2692 9.82843 7.46447L7 10.2929L4.17157 7.46447C3.97631 7.2692 3.65973 7.2692 3.46447 7.46447C3.2692 7.65973 3.2692 7.97631 3.46447 8.17157L6.64645 11.3536ZM6.5 2L6.5 11L7.5 11L7.5 2L6.5 2Z" />
    </svg>
  ),

  sortUp: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.35355 2.64645C7.15829 2.45118 6.84171 2.45118 6.64645 2.64645L3.46447 5.82843C3.2692 6.02369 3.2692 6.34027 3.46447 6.53553C3.65973 6.7308 3.97631 6.7308 4.17157 6.53553L7 3.70711L9.82843 6.53553C10.0237 6.7308 10.3403 6.7308 10.5355 6.53553C10.7308 6.34027 10.7308 6.02369 10.5355 5.82843L7.35355 2.64645ZM7.5 12L7.5 3L6.5 3L6.5 12L7.5 12Z" />
    </svg>
  ),

  star: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_609_40119)">
        <path
          d="M7.96005 4.25081L11.4974 4.76442L8.9377 7.26214L8.74961 7.44568L8.79413 7.70469L9.40001 11.23L9.39873 11.23L6.23257 9.56544L5.99969 9.443L5.7669 9.56561L2.5999 11.2336L2.59967 11.2337L2.59968 11.2337L3.20568 7.70769L3.25019 7.44868L3.0621 7.26514L0.500098 4.76514L0.499756 4.76481L4.03975 4.25081L4.30018 4.213L4.41645 3.97692L5.98343 0.795345C5.98464 0.794197 5.98599 0.793192 5.98744 0.792355C5.99062 0.790528 5.99423 0.789566 5.9979 0.789566C6.00157 0.789566 6.00518 0.790528 6.00836 0.792355C6.00984 0.793206 6.01121 0.794232 6.01243 0.795404L7.58357 3.97737L7.69994 4.21304L7.96005 4.25081Z"
          stroke="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_609_40119">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  still: (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="4.5"
        cy="4.5"
        rx="4.5"
        ry="4.5"
        transform="rotate(-180 4.5 4.5)"
        fill="#9A9A9A"
        fillOpacity="0.2"
      />
      <line
        x1="3.5"
        y1="4.5"
        x2="5.5"
        y2="4.5"
        stroke="#9A9A9A"
        strokeLinecap="round"
      />
    </svg>
  ),

  strategies: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.292968 5.70703C0.683602 6.09767 1.31639 6.09767 1.70702 5.70703L2.99999 4.41406L4.29295 5.70703C4.68358 6.09767 5.31637 6.09767 5.70701 5.70703C6.09763 5.31641 6.09763 4.68359 5.70701 4.29297L4.41404 3L5.70701 1.70703C6.09763 1.31641 6.09763 0.683594 5.70701 0.292969C5.31638 -0.0976562 4.68357 -0.0976562 4.29295 0.292969L2.99999 1.58594L1.70702 0.292969C1.3164 -0.0976561 0.683591 -0.0976561 0.292967 0.292969C-0.0976558 0.683594 -0.0976558 1.31641 0.292967 1.70703L1.58593 3L0.292968 4.29297C-0.0976557 4.68359 -0.0976557 5.31641 0.292968 5.70703Z" />
      <path d="M15.707 10.293C15.3164 9.90234 14.6836 9.90234 14.2929 10.293L13 11.5859L11.707 10.293C11.3164 9.90234 10.6836 9.90234 10.293 10.293C9.90234 10.6836 9.90234 11.3164 10.293 11.707L11.5859 13L10.293 14.293C9.90234 14.6836 9.90234 15.3164 10.293 15.707C10.4883 15.9023 10.7441 16 11 16C11.2559 16 11.5117 15.9023 11.707 15.707L13 14.4141L14.2929 15.707C14.4883 15.9023 14.7441 16 15 16C15.2558 16 15.5117 15.9023 15.707 15.707C16.0976 15.3164 16.0976 14.6836 15.707 14.293L14.414 13L15.707 11.707C16.0976 11.3164 16.0976 10.6836 15.707 10.293Z" />
      <path d="M14.9999 0H9.99995V2H12.5859L6.0192 8.56671C5.42429 8.21539 4.7396 8 3.99998 8C1.79394 8 0 9.79443 0 12C0 14.2056 1.79394 16 3.99998 16C6.20603 16 7.99996 14.2056 7.99996 12C7.99996 11.2604 7.78451 10.5758 7.43319 9.98083L13.9999 3.41406V6H15.9999V1C15.9999 0.447754 15.5527 0 14.9999 0ZM3.99998 14C2.89745 14 1.99999 13.103 1.99999 12C1.99999 10.897 2.89745 10 3.99998 10C5.10252 10 5.99997 10.897 5.99997 12C5.99997 13.103 5.10252 14 3.99998 14Z" />
    </svg>
  ),

  trash: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 0H4V2H1V4H11V2H8V0Z" />
      <path d="M8 10H4V6H2V11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12H9C9.26522 12 9.51957 11.8946 9.70711 11.7071C9.89464 11.5196 10 11.2652 10 11V6H8V10Z" />
    </svg>
  ),

  twitter: (
    <svg
      viewBox="0 0 100 102.25"
      width="12"
      height="12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 59.517 43.275 L 96.742 0 L 87.917 0 L 55.592 37.575 L 29.775 0 L 0 0 L 39.042 56.817 L 0 102.2 L 8.825 102.2 L 42.958 62.517 L 70.225 102.2 L 100 102.2 L 59.508 43.275 L 59.517 43.275 Z M 47.433 57.317 L 43.475 51.658 L 12 6.642 L 25.55 6.642 L 50.95 42.975 L 54.908 48.633 L 87.925 95.858 L 74.375 95.858 L 47.433 57.325 L 47.433 57.317 Z"
        transform="matrix(1, 0, 0, 1, 1.4210854715202004e-14, 0)"
      />
    </svg>
  ),

  upload: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M81.25 44.375V43.75C81.25 26.25 67.5 12.5 50 12.5C34.375 12.5 21.25 23.75 19.375 39.375C8.125 43.125 0 53.125 0 65.625C0 81.25 12.5 93.75 28.125 93.75C38.75 93.75 65 93.75 75 93.75C88.75 93.75 100 82.5 100 68.75C100 56.875 91.875 47.5 81.25 44.375ZM56.25 62.5V81.25H43.75V62.5H25L50 37.5L75 62.5H56.25Z" />
    </svg>
  ),

  viewGraph: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 0H1C0.4 0 0 0.4 0 1V6C0 6.6 0.4 7 1 7H6C6.6 7 7 6.6 7 6V1C7 0.4 6.6 0 6 0Z" />
      <path d="M15 0H10C9.4 0 9 0.4 9 1V6C9 6.6 9.4 7 10 7H15C15.6 7 16 6.6 16 6V1C16 0.4 15.6 0 15 0Z" />
      <path d="M6 9H1C0.4 9 0 9.4 0 10V15C0 15.6 0.4 16 1 16H6C6.6 16 7 15.6 7 15V10C7 9.4 6.6 9 6 9Z" />
      <path d="M15 9H10C9.4 9 9 9.4 9 10V15C9 15.6 9.4 16 10 16H15C15.6 16 16 15.6 16 15V10C16 9.4 15.6 9 15 9Z" />
    </svg>
  ),

  viewGrid: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 0H0V4H4V0Z" />
      <path d="M10 0H6V4H10V0Z" />
      <path d="M16 0H12V4H16V0Z" />
      <path d="M4 6H0V10H4V6Z" />
      <path d="M10 6H6V10H10V6Z" />
      <path d="M16 6H12V10H16V6Z" />
      <path d="M4 12H0V16H4V12Z" />
      <path d="M10 12H6V16H10V12Z" />
      <path d="M16 12H12V16H16V12Z" />
    </svg>
  ),

  viewList: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z" />
      <path d="M16 1H6V3H16V1Z" />
      <path d="M2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10Z" />
      <path d="M16 7H6V9H16V7Z" />
      <path d="M2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.89543 12 0 12.8954 0 14C0 15.1046 0.89543 16 2 16Z" />
      <path d="M16 13H6V15H16V13Z" />
    </svg>
  ),

  wand: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M99.5075 30.0878C91.409 31.3726 89.4118 33.3682 88.0985 41.4874C87.9891 42.1709 87.0315 42.1709 86.922 41.4874C85.6361 33.3956 83.6389 31.3999 75.513 30.0878C74.829 29.9784 74.829 29.0216 75.513 28.9122C83.6115 27.6274 85.6088 25.6318 86.922 17.5126C87.0315 16.8291 87.9891 16.8291 88.0985 17.5126C89.3844 25.6044 91.3817 27.6001 99.5075 28.9122C100.164 29.0216 100.164 29.9784 99.5075 30.0878Z" />
      <path d="M10.7529 81.3115C8.35929 83.5155 4.62976 83.5713 2.18051 81.4231C-0.630548 78.94 -0.714045 74.6435 1.87436 72.0489C2.598 71.3235 3.4608 70.7934 4.37927 70.4865C7.49649 69.4543 10.391 67.8082 12.7568 65.5205L63.5786 17.3941C64.1352 16.8641 65.0259 16.8641 65.5825 17.422C65.8608 17.701 66 18.0637 66 18.4264C66 18.7891 65.8608 19.1518 65.6103 19.4308L17.5718 70.1239C15.2895 72.4674 13.5083 75.2852 12.562 78.41C12.2558 79.498 11.6435 80.5024 10.7529 81.3115Z" />
    </svg>
  ),

  warning: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 95.3125C75.0254 95.3125 95.3125 75.0254 95.3125 50C95.3125 24.9746 75.0254 4.6875 50 4.6875C24.9746 4.6875 4.6875 24.9746 4.6875 50C4.6875 75.0254 24.9746 95.3125 50 95.3125Z"
        stroke="#121212"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50 21.875V60.9375"
        stroke="#FF2B00"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50 75C50.8629 75 51.5625 74.3004 51.5625 73.4375C51.5625 72.5746 50.8629 71.875 50 71.875C49.1371 71.875 48.4375 72.5746 48.4375 73.4375C48.4375 74.3004 49.1371 75 50 75Z"
        stroke="#FF2B00"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  wikipedia: (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
    >
      <path
        id="Layer"
        className="s0"
        d="m12 3v0.3q-0.5 0-0.8 0.3c-0.3 0.2-0.6 0.6-0.8 1.1l-4.1 8.3h-0.2l-4.1-8.4c-0.2-0.5-0.5-0.7-0.6-0.8q0-0.1-0.1-0.1 0-0.1-0.1-0.1 0-0.1-0.1-0.1-0.1-0.1-0.1-0.1-0.3-0.1-0.7-0.1v-0.3h3.9v0.3c-0.4 0-0.6 0.1-0.8 0.2q-0.2 0.2-0.2 0.4 0 0.4 0.4 1.1l3 5.8 2.9-5.7c0.3-0.5 0.5-0.9 0.5-1.2q0-0.2-0.2-0.4c-0.2-0.1-0.3-0.2-0.7-0.2q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0v-0.3c0 0 3 0 3 0z"
      />
      <path
        id="Layer"
        className="s0"
        d="m15.5 3v0.3q-0.5 0-0.8 0.3c-0.3 0.2-0.6 0.6-0.8 1.1l-3.6 8.3h-0.2l-3.8-8.4c-0.2-0.5-0.5-0.7-0.5-0.8q-0.1-0.1-0.1-0.1-0.1-0.1-0.2-0.1 0-0.1-0.1-0.1 0-0.1-0.1-0.1c-0.2-0.1-0.3-0.1-0.6-0.1v-0.3h3.9v0.3c-0.5 0-0.7 0.1-0.8 0.2q-0.3 0.2-0.3 0.4 0 0.4 0.4 1.1l2.7 5.8 2.5-5.7c0.2-0.5 0.4-0.9 0.4-1.2q0-0.2-0.2-0.4-0.2-0.1-0.7-0.2-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0v-0.3c0 0 3.1 0 3.1 0z"
      />
    </svg>
  ),

  youtube: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1200 1200">
      <circle fill="#da0000" cx="600" cy="600" r="500" />
      <path
        fill="#fff"
        d="M919.4,439.54c-7.67-28.68-30.26-51.27-58.94-58.94-51.99-13.93-260.46-13.93-260.46-13.93,0,0-208.47,0-260.46,13.93-28.68,7.67-51.27,30.26-58.94,58.94-13.93,51.99-13.93,160.46-13.93,160.46,0,0,0,108.47,13.93,160.46,7.67,28.68,30.26,51.27,58.94,58.94,51.99,13.93,260.46,13.93,260.46,13.93,0,0,208.47,0,260.46-13.93,28.68-7.67,51.27-30.26,58.94-58.94,13.93-51.99,13.93-160.46,13.93-160.46,0,0,0-108.47-13.93-160.46Zm-386.07,260.46v-200l173.2,100-173.2,100Z"
      />
    </svg>
  ),

  zoomIn: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1303_144385)">
        <path d="M12.7 11.3C13.6 10.1 14.1 8.7 14.1 7.1C14.1 3.2 11 0 7.1 0C3.2 0 0 3.2 0 7.1C0 11 3.2 14.2 7.1 14.2C8.7 14.2 10.2 13.7 11.3 12.8L14.3 15.8C14.5 16 14.8 16.1 15 16.1C15.2 16.1 15.5 16 15.7 15.8C16.1 15.4 16.1 14.8 15.7 14.4L12.7 11.3ZM7.1 12.1C4.3 12.1 2 9.9 2 7.1C2 4.3 4.3 2 7.1 2C9.9 2 12.2 4.3 12.2 7.1C12.2 9.9 9.9 12.1 7.1 12.1Z" />
        <path d="M8 4H6V6H4V8H6V10H8V8H10V6H8V4Z" />
      </g>
      <defs>
        <clipPath id="clip0_1303_144385">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};
